<template>
    <v-container fluid>
        <v-row>
            <v-col cols="3" class="ps-0 pt-0">
                <v-card tile class="mx-auto" height="100%">
                    <v-toolbar dense color="primary" dark>
                        <h3>
                            {{ $t('Tasks') }}
                        </h3>
                        <v-spacer />
                        <v-avatar size="36" small color="secondary">
                            <span class="white--text">{{ totalCount }}</span>
                        </v-avatar>
                    </v-toolbar>
                    <v-overlay :absolute="absolute" :value="loading">
                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                    </v-overlay>
                    <v-list two-line dense>
                        <v-list-item-group v-model="selected" active-class="primary--text">
                            <template v-for="(item, index) in tasks">
                                <v-list-item :key="item.activityInstanceId" :disabled="itemDisabled" @click="showData(item)" :class="{ claimed:item.claimed}">
                                    <template>
                                        <v-list-item-content>
                                            <div v-text="item.title" v-if="item.claimed" />
                                            <h6 v-else v-text="item.title" />

                                            <v-list-item-subtitle :class="!item.claimed ? 'primary--text' : ''">
                                                <span class="my-1">{{ item.processTitle }}</span>
                                            </v-list-item-subtitle>

                                            <v-list-item-subtitle class="mt-1">
                                                <span class="my-1">
                                                    {{ $t('StartDate')}} : {{ item.plannedStartDate | formatDateGregorian }} | {{ $t('DueDate') }} : {{ item.dueDate | formatDateGregorian }}
                                                </span>
                                                <v-chip small label color="primary" class="mt-2">{{ item.referenceNumber }}</v-chip>
                                            </v-list-item-subtitle>


                                        </v-list-item-content>
                                        <v-list-item-action>
                                            <v-chip small label color="grey lighten-2"> <b class="black--text"> <v-list-item-action-text v-text="item.activityInstanceId" /></b></v-chip>
                                            <v-icon size="20" v-if="item.isDelayed" color="error">mdi-calendar-clock</v-icon>
                                            <v-icon size="20" v-else color="teal">mdi-calendar-clock</v-icon>
                                        </v-list-item-action>
                                    </template>
                                </v-list-item>
                                <v-divider v-if="index < tasks.length - 1" :key="index" />
                            </template>
                            <div v-if="tasks.length == 0" class="text-center">
                                {{ $t('NoItemsToShow') }}
                            </div>
                        </v-list-item-group>
                    </v-list>
                    <v-divider />
                    <v-pagination v-model="page" class="pagination"
                                  :length="totalPages"
                                  total-visible="5"
                                  next-icon="mdi-menu-right"
                                  prev-icon="mdi-menu-left"
                                  @input="handlePageChange" />
                </v-card>
            </v-col>
            <v-divider vertical />
            <v-col cols="9" class="pt-0">
                <v-card tile min-height="90vh" color="transparent" class="elevation-0">
                    <v-card-text v-if="show" class="pa-0">
                        <Dynamic v-if="isDynamic && taskId" :task-id="taskId" @completed="activityCompleted" />
                        <SurveyApproval v-if="isSurveyApproval && taskId" :task-id="taskId" @completed="activityCompleted" />
                    </v-card-text>
                    <v-card-text v-else>
                        <v-alert border="right" tile class="text-center">
                            {{ $t('NoItemsToShow') }}
                        </v-alert>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>

    import Dynamic from '@/components/app/task/dynamic/TaskDetails.vue'
    import SurveyApproval from '@/components/app/task/survey/TaskDetails.vue'

    import { connection } from '@/plugins/hub/myHubPlugin.js'
    import TasksService from '@/services/TasksService.js'
    import { ProcessTypesEnum } from '@/helpers/constants/enumerations.js'

    export default {

        components: {
            Dynamic, SurveyApproval
        },

        data() {

            return {
                show: false,
                itemDisabled: false,
                loading: false,
                selected: [2],
                tasks: [],
                taskId: null,
                totalCount: 0,
                page: 1,
                totalPages: 0,
                pageSize: 7,
                processType: null,
                absolute: true,
            }

        },

        computed: {
            isDynamic() {
                return !this.isSurveyApproval
            },

            isSurveyApproval() {
                return this.processType == ProcessTypesEnum.SurveyApproval
            }
        },

        created() {
            this.loadTasks()
        },

        mounted() {
            connection.on('ReceiveChanges', () => {
                this.loadTasks()
            })
        },

        methods: {
            loadTasks() {
                this.loading = true
                TasksService.listTasks(this.page, this.pageSize).then((res) => {
                    this.tasks = res.data.data
                    this.totalCount = res.data.total
                    this.totalPages = Math.ceil(res.data.total / this.pageSize)
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                })
            },

            showData(activity) {
                this.claimTask(activity)
                if (this.taskId != activity.activityInstanceId) {
                    this.show = false
                    TasksService.getProcesType(activity.activityInstanceId).then(res => {
                        this.taskId = activity.activityInstanceId
                        this.processType = res.data
                        this.show = true
                    }).catch(() => {
                        this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                    }).finally(() => {
                        this.loading = false
                    })
                }
            },

            handlePageChange(value) {
                this.page = value
                this.loadTasks()
            },

            claimTask(activity) {
                activity.claimed = true
                TasksService.claimActivity(activity.activityInstanceId).then(res => {

                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                })
            },

            activityCompleted(success) {
                if (success) {
                    this.loadTasks()
                    this.taskId = null
                    this.processType = null
                }
            },

        },
    }
</script>
<style scoped>
    .pagination { margin: 0 auto; position: absolute; bottom: 0 }
    .claimed { background: !important }
</style>